module.exports = "/_next/static/images/umbrella-monotone-2cd8d4c7cbc7f9786579b98e2fa99206.svg";